import React from 'react';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import Title from '@zola/zola-ui/src/components/PreAuthV3/HighlightTitle';

import {
  ExpertAdviceContainer,
  ExpertAdviceTiles,
  ExpertAdviceTileContainer,
  ExpertAdviceTileTitle,
  ExpertAdviceTileImage,
} from './ExpertAdvice.style';

interface ExpertAdviceTileProps {
  title: string;
  link: string;
  img: string;
}

const ExpertAdviceTile: React.FC<ExpertAdviceTileProps> = ({ title, link, img }) => (
  <ExpertAdviceTileContainer>
    <LinkV2 href={link} noUnderline>
      <ExpertAdviceTileImage>
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 1)"
          srcSet={`${img}?w=635&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 1)"
          srcSet={`${img}?w=635&fm=jpg`}
          type="image/jpeg"
        />
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 2)"
          srcSet={`${img}?w=1270&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 2)"
          srcSet={`${img}?w=1270&fm=jpg`}
          type="image/jpeg"
        />
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 3)"
          srcSet={`${img}?w=1905&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 992px) and (-webkit-min-device-pixel-ratio: 3)"
          srcSet={`${img}?w=1905&fm=jpg`}
          type="image/jpeg"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 1)"
          srcSet={`${img}?w=929&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 1)"
          srcSet={`${img}?w=929&fm=jpg`}
          type="image/jpeg"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 2)"
          srcSet={`${img}?w=1858&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 2)"
          srcSet={`${img}?w=1858&fm=jpg`}
          type="image/jpeg"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 3)"
          srcSet={`${img}?w=2787&fm=webp`}
          type="image/webp"
        />
        <source
          media="(min-width: 768px) and (-webkit-min-device-pixel-ratio: 3)"
          srcSet={`${img}?w=2787&fm=jpg`}
          type="image/jpeg"
        />
        <img src={img} alt={title} />
      </ExpertAdviceTileImage>
      <ExpertAdviceTileTitle>{title}</ExpertAdviceTileTitle>
    </LinkV2>
  </ExpertAdviceTileContainer>
);

interface ExpertAdviceProps {
  advices: ExpertAdviceTileProps[];
}

export const ExpertAdvice: React.FC<ExpertAdviceProps> = ({ advices }) => (
  <ExpertAdviceContainer>
    <Title isH1={false}>
      <span>Advice and answers</span> for every question
    </Title>

    <ExpertAdviceTiles>
      {advices.map((advice, index) => (
        <ExpertAdviceTile key={index} {...advice} />
      ))}
    </ExpertAdviceTiles>

    <ButtonV3 component="a" href="/expert-advice">
      Get more advice
    </ButtonV3>
  </ExpertAdviceContainer>
);
